<template>
    <console-content max-width="1024">

        <v-row class="mt-4 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">
                <span v-if="$route.params._giftcard">상품권 상세</span>
                <span v-else>상품권 등록</span>
            </v-col>
            <v-spacer/>
        </v-row>

        <v-row class="mt-4">
            <v-col cols="12" md="8" class="py-0 pr-md-1">
                <v-card class="mx-1" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-title class="subtitle-2"><v-icon color="blue" small class="mr-2">mdi-minus</v-icon>기본정보</v-card-title>
                    <v-card-text>
                        <v-select v-model="giftcard.brand" label="브랜드" placeholder=" " :items="brands" item-text="name" item-value="code" hide-details />
                        <v-select v-model="giftcard.category" label="카테고리" placeholder=" " :items="categories" item-text="name" item-value="code" hide-details class="mt-4" />
                        <v-text-field v-model="giftcard.name" label="상품권이름" placeholder=" " hide-details class="mt-4" />
                        <v-text-field  v-if="$route.params._giftcard" v-model="giftcard._id" label="상품권코드(대대행)" readonly placeholder=" " hide-details class="mt-4" />
                        <giftcard-thumb v-model="giftcard.thumb" class="mt-4" />
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="4" class="py-0 pl-md-1">
                <v-card class="mx-1 mt-4 mt-md-0" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-title>
                        <v-select v-model="giftcard.mode" label="구분" placeholder=" " :items="modes" item-text="text" item-value="value" hide-details />
                    </v-card-title>
                </v-card>
                <v-card class="mx-1 mt-4" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-text>
                        <v-text-field v-model="giftcard.sequence" label="순서" placeholder=" " hide-details class="mt-0"/>
                        <v-text-field v-model="giftcard.faceamt" label="권종" type="number" hide-details class="mt-4"/>
                        <v-row>
                            <v-col>
                                <v-text-field v-model="giftcard.cpamt" label="현재 api 가격" type="number" placeholder=" " hide-details class="mt-4" disabled/>
                            </v-col>
                            <v-col>
                                <v-text-field v-model="giftcard.cpamtRate" label="api 할인율" type="number" placeholder=" " hide-details class="mt-4"/>
                            </v-col>
                            <v-col>
                                <v-text-field v-model="cpamt" label="api 가격" hide-details class="mt-4" readonly/>
                            </v-col>
                        </v-row>
                        <v-text-field v-model="giftcard.stock" label="재고" placeholder=" " :disabled="isBulk" hide-details class="mt-4"/>
                        <v-text-field v-if="giftcard.mode === 'paper'" v-model="giftcard.minimumPurchase" label="최소 구매 가능 수량(지류)" type="number" placeholder=" " hide-details class="mt-4"/>
                        <giftcard-cp-price-dialog v-bind="{ _giftcard: $route.params._giftcard }">
                            <template #activator="{ on, attrs }">
                                <v-btn v-bind="attrs" hide-details class="mt-4" width="100%" color="yellow lighten-2" v-on="on">CP</v-btn>
                            </template>
                        </giftcard-cp-price-dialog>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-card class="mx-1 mt-4" :disabled="!$hasScope(['root', 'admin'])">
            <v-card-title class="subtitle-2 align-center">
                <v-icon color="blue" small class="mr-2">mdi-minus</v-icon>제공업체
                <v-spacer />
                <v-select v-model="giftcard.platform" :items="platforms" item-text="text" item-value="value" placeholder=":: 플랫폼 ::" hide-details class="col-auto pa-0 mt-0" :disabled="!!giftcard._id" />
            </v-card-title>
            <v-divider />
            <v-card-text v-if="giftcard.platform && giftcard.mode == 'mobile'">
                <v-text-field v-model="giftcard.code" label="상품권 코드" placeholder=" " hide-details />
                <v-row v-if="giftcard.platform == 'galaxia'" class="mt-4">
                    <v-col class="py-0">
                        <v-select v-model="giftcard.kindType" :items="kindTypes" label="kindType" placeholder=" " hide-details />
                    </v-col>
                    <v-col class="py-0">
                        <v-select v-model="giftcard.saleType" :items="saleTypes" label="saleType" placeholder=" " hide-details />
                    </v-col>
                    <v-col class="py-0">
                        <v-select v-model="giftcard.messageType" :items="messageTypes" label="messageType" placeholder=" " hide-details />
                    </v-col>
                </v-row>
                <v-row v-if="giftcard.platform == 'barocon'" class="mt-4">
                    <v-col class="py-0">
                        <v-text-field v-model="giftcard.campaignCode" label="캠페인코드" hide-details />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-card class="mx-1 mt-4" :disabled="!$hasScope(['root', 'admin'])">
            <v-card-title class="subtitle-2"><v-icon color="blue" small class="mr-2">mdi-minus</v-icon>과금 및 진열설정</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col class="py-0">
                        <v-select v-model="giftcard.unknownEnabled" :items="enableds" item-text="text" value="value" label="비회원" placeholder=" " hide-details />
                    </v-col>
                    <v-col class="py-0"></v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col class="py-0">
                        <v-select v-model="giftcard.normalEnabled" :items="enableds" item-text="text" value="value" label="normal" placeholder=" " hide-details />
                    </v-col>
                    <v-col class="py-0">
                        <v-text-field v-model="giftcard.normalCommission" label="normal(%)" placeholder=" " hide-details />
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col class="py-0">
                        <v-select v-model="giftcard.vipEnabled" :items="enableds" item-text="text" value="value" label="vip" placeholder=" " hide-details />
                    </v-col>
                    <v-col class="py-0">
                        <v-text-field v-model="giftcard.vipCommission" label="vip(%)" placeholder=" " hide-details />
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col class="py-0">
                        <v-select v-model="giftcard.vvipEnabled" :items="enableds" item-text="text" value="value" label="vvip" placeholder=" " hide-details />
                    </v-col>
                    <v-col class="py-0">
                        <v-text-field v-model="giftcard.vvipCommission" label="vvip(%)" placeholder=" " hide-details />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <giftcard-options v-if="isBulk" :giftcard="giftcard"/>

        <v-card class="mx-1 mt-4">
            <v-card-title class="subtitle-2"><v-icon color="blue" small class="mr-2">mdi-minus</v-icon>상세정보</v-card-title>
            <v-card-text class="py-0">
                <!-- <v-textarea v-model="giftcard.content" rows="8" class="mt-0 py-0"/> -->
                <naver-smarteditor v-if="loaded" v-model="giftcard.content"/>
            </v-card-text>
        </v-card>

        <!-- <v-card v-if="giftcard.platform === 'payletter'" class="mx-1 mt-4"> -->
        <v-card v-if="['payletter', 'barocon', 'chlifes'].includes(giftcard.platform)" :disabled="!$hasScope(['root', 'admin'])" class="mx-1 mt-4">
            <v-card-title class="subtitle-2"><v-icon color="blue" small class="mr-2">mdi-minus</v-icon>사용정보</v-card-title>
            <v-card-text class="py-0">
                <v-radio-group v-model="giftcard.sendMethod" row>
                <v-radio label="알림톡(텍스트)" value="ATS" ></v-radio>
                <v-radio label="친구톡(이미지포함)" value="FMS" ></v-radio>
                </v-radio-group>
            </v-card-text>
            <v-card-text v-if="giftcard.sendMethod === 'FMS'">
                <giftcard-send-image v-model="giftcard.sendImage" />
            </v-card-text>
            <v-card-text class="py-0">
                <v-textarea v-model="giftcard.sendInfo" outlined rows="8" class="mt-0 py-0"/>
            </v-card-text>
        </v-card>

        <v-row class="my-6">
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <!-- <v-btn color="primary" @click="open">미릭보기</v-btn>
            </v-col>
            <v-col cols="auto" class="py-0"> -->
                <v-btn :disabled="!$hasScope(['root', 'admin'])" color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer />
        </v-row>
        <!-- <giftcard-dialog ref="giftcardDialog"/> -->
    </console-content>
</template>

<script>
import api from "@/api";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import GiftcardThumb from "@/components/console/shop/giftcards/giftcard-thumb.vue";
import GiftcardOptions from "@/components/console/shop/giftcards/giftcard-options.vue";
import GiftcardSendImage from "@/components/console/shop/giftcards/giftcard-send-image.vue";
import CategorySelect from "@/components/console/shop/categories/category-select.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
// import giftcardDialog from '@/components/console/shop/giftcards/giftcard-dialog.vue'
import GiftcardCpPriceDialog from "@/components/console/shop/giftcards/giftcard-cp-price-dialog.vue";;
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
        GiftcardThumb,
        GiftcardOptions,
        GiftcardSendImage,
        CategorySelect,
        NaverSmarteditor,
        GiftcardCpPriceDialog
        // giftcardDialog
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            loaded: false,

            giftcard: {
                category: null,
                name: null,
                thumb: null,
                mode: "mobile",
                sequence: null,
                faceamt: 0,
                cpamtRate: 0,
                stock: 0,
                minimumPurchase: 0,

                code: null,
                kindType: null,
                saleType: null,
                messageType: null,

                unknownEnabled: false,
                normalEnabled: false,
                normalCommission: 0,
                vipEnabled: false,
                vipCommission: 0,
                vvipEnabled: false,
                vvipCommission: 0,

                content: null,

                sendMethod: "ATS",
                sendImage: null,
                sendInfo: null,
            },

            categories: [],
            brands: [],

            modes: [
                { text: "모바일", value: "mobile" },
                { text: "지류", value: "paper" },
            ],

            enableds: [
                { text: "표시", value: true },
                { text: "표시안함", value: false },
            ],

            platforms: [
            { text: ":: 전체 ::", value: null },
                { text: "갤럭시아", value: "galaxia" },
                { text: "페이즈", value: "pays" },
                { text: "페이즈(벌크)", value: "pays(bulk)" },
                { text: "다날", value: "danal" },
                { text: "컬쳐랜드", value: "cultureland" },
                { text: "한국문화진흥", value: "cultureland2" },
                { text: "S-OIL", value: "soil" },
                { text: "토핑", value: "topping" },
                { text: "캐시박스", value: "payletter" },
                { text: "해피머니(벌크)", value: "happymoney(bulk)" },
                { text: "티사이언티픽", value: "tscientific" },
                { text: "더블엔씨", value: "barocon" },
                { text: "클라이프스", value: "chlifes" },
                { text: "나누리상품권", value: "momopin" },
            ],

            kindTypes: ["dept", "cpn"],
            saleTypes: ["B2B", "B2C"],
            messageTypes: ["SMS", "MMS"]
        }
    },
    computed: {
        isBulk() {
            return ["pays(bulk)", "happymoney(bulk)"].includes(this.giftcard.platform)
        },
        isEdit() {
            return !!this.$router.params._giftcard
        },
        cpamt() {
            return Math.round(this.giftcard.faceamt * (1 - this.giftcard.cpamtRate / 100));
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { categories } = await api.console.shop.categories.gets({ params: { depth: 1 }, headers: { limit: 0 } });
            this.categories = categories;

            let { brands } = await api.console.shop.brands.gets({ headers: { limit: 0 } });
            this.brands = brands;

            let { summary } = await api.console.shop.giftcards.gets();
            this.giftcard.sequence = summary.totalCount + 1;

            let _giftcard = this.$route.params._giftcard ?? this.$route.query._giftcard;
            if(_giftcard){
                let { giftcard } = await api.console.shop.giftcards.get({ _id: _giftcard });
                if(giftcard.thumb) giftcard.thumb = await api.getResource(giftcard.thumb);
                if (giftcard.sendImage) giftcard.sendImage = await api.getResource(giftcard.sendImage);

                this.giftcard = {
                    ...this.giftcard,
                    ...giftcard,
                };

                if(this.$route.query._giftcard) delete this.giftcard._id;

                this.loaded = true;
            }
        },
        validate(){
            try{
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async save(){
            if(this.validate()){
                // 할인율 적용 후, 반올림값 저장
                this.giftcard.cpamt = this.cpamt;
                this.giftcard.cpamtOptions = (this.giftcard.cpamtOptions || []).map((item) => ({
                    ...item,
                    price: Math.round(this.giftcard.faceamt * (1 - item.discountRate / 100)),
                }));

                let { giftcard } = this.giftcard._id ? await api.console.shop.giftcards.put(this.giftcard) : await api.console.shop.giftcards.post(this.giftcard);
                if(this.giftcard.thumb) await api.console.shop.giftcards.thumb.post(giftcard._id, this.giftcard.thumb);
                if(this.giftcard.sendImage) await api.console.shop.giftcards.image.post(giftcard._id, this.giftcard.sendImage);

                alert("저장되었습니다");
                this.$router.go(-1);
            }
        }, 
        open(){
            this.$refs.giftcardDialog.giftcard = this.giftcard;
            this.$refs.giftcardDialog.open();
        }
    }
}
</script>